// extracted by mini-css-extract-plugin
module.exports = {"formHolder":"Machinery_formHolder__vHH4n","formHolderIn":"Machinery_formHolderIn__kBQyy","formHolderBody":"Machinery_formHolderBody__2dn6E"};